import { GripVertical } from "lucide-react";
import { Reorder, useDragControls } from "motion/react";
import { Checkbox, cn, V2Label } from "web-design-system";
import type { EditFieldsProps } from "./edit-fields";

export function ReorderableColumn({
  columnConfig,
  onVisibilityChange,
}: {
  columnConfig: EditFieldsProps["columnsConfig"][number];
  onVisibilityChange?: (checked: boolean) => void;
}) {
  const controls = useDragControls();

  return (
    <Reorder.Item
      dragListener={false}
      dragControls={controls}
      key={columnConfig.id}
      value={columnConfig.id}
    >
      <div
        className={cn(
          "flex flex-row p-2 gap-2 items-center",
          !columnConfig.visible && "hidden"
        )}
      >
        <Checkbox
          id={`reorderable-${columnConfig.id}`}
          checked={columnConfig.visible}
          disabled={!columnConfig.configurable}
          onCheckedChange={(checked) => onVisibilityChange?.(!!checked)}
        />
        <V2Label htmlFor={`reorderable-${columnConfig.id}`}>
          {columnConfig.label}
        </V2Label>
        <GripVertical
          onPointerDown={(e) => controls.start(e)}
          className="size-4 ml-auto cursor-grab"
        />
      </div>
    </Reorder.Item>
  );
}
